"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeChatWidget = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = __importDefault(require("react-dom/client"));
var index_1 = __importDefault(require("./components/ChatWidget/index"));
var config_1 = require("./constants/config");
// Create and export a global function to render the widget for embedding purposes
var initializeChatWidget = function () { return __awaiter(void 0, void 0, void 0, function () {
    var div, root;
    return __generator(this, function (_a) {
        try {
            console.log('Initializing chat widget...');
            div = document.createElement('div');
            div.id = (0, config_1.getWidgetConfig)().divId;
            div.style.position = 'fixed';
            div.style.bottom = '0px';
            div.style.right = '0px';
            div.style.zIndex = '1000';
            document.body.appendChild(div);
            root = client_1.default.createRoot(div);
            root.render(react_1.default.createElement(index_1.default, null));
        }
        catch (error) {
            console.error('Failed to initialize chat widget:', error);
        }
        return [2 /*return*/];
    });
}); };
exports.initializeChatWidget = initializeChatWidget;
console.log('Window loaded, initializing widget... First step', window);
if (typeof window !== 'undefined') {
    // console.log(' First step under if',window);
    var runWidgetInitialization = function () { return __awaiter(void 0, void 0, void 0, function () {
        var parentOrigin, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('Window loaded, initializing widget... Second step');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, (0, config_1.initializeWidgetConfig)()];
                case 2:
                    _a.sent();
                    parentOrigin = (0, config_1.getWidgetConfig)().parentOrigin;
                    data = (0, config_1.getWidgetConfig)().domains.includes(parentOrigin);
                    console.log('this is the window parent origin from the widget', parentOrigin);
                    if (!data) return [3 /*break*/, 4];
                    //    console.log('this is data in the second step',data)
                    return [4 /*yield*/, (0, exports.initializeChatWidget)()];
                case 3:
                    //    console.log('this is data in the second step',data)
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    console.log('Please check your widget configuration');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    if (document.readyState === 'complete') {
        // The page is already loaded, so run the initialization immediately.
        runWidgetInitialization();
    }
    else {
        // The page is still loading, so wait for the 'load' event.
        window.addEventListener('load', runWidgetInitialization);
    }
}
else {
    console.log('Not Initialized');
}
